var CustomerConcernsCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state, ssWidgetService, $q, $timeout, authToken) {
    Object.defineProperty($scope, 'concernsDescription', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            customerModelService.setConcernsDescription(value);
        },
        get: function () {
            return customerModelService.getConcernsDescription();
        }
    });

    Object.defineProperty($scope, 'concernsDescriptionVisible', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            throw new Error('You can not set read only property');
        },
        get: function () {
            return window.appSettings.enableGeneralCommentsBox || false;
        }
    });

    Object.defineProperty($scope, 'showLineComment', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            throw new Error('You can not set read only property');
        },
        get: function () {
            return window.appSettings.displayConcernsLineComments || false;
        }
    });


    function loadSymptomSurveysWidget() {

        var deferred = $q.defer();

        var widgetEnabled = true;

        if (!widgetEnabled) {
            deferred.resolve();
        } else {
            var loadSubscription = ssWidgetService.onLoad(function (ev) {
                deferred.resolve();
            });

            var errorSubscription = ssWidgetService.onError(function (ev) {
                console.error(ev);
                deferred.resolve();
            });

            $scope.$on('$destroy', function () {
                ssWidgetService.off(loadSubscription);
                ssWidgetService.off(errorSubscription);
            });

            var ssWidgetContainer = document.getElementById('ssWidgetContainer');
            ssWidgetContainer.classList.add('ss-widget');

            $timeout(function () {
                ssWidgetService.loadWidget(ssWidgetContainer);
            });
        }

        return deferred.promise;

    }

    function processServices(appServices, ossServices) {
        //_.forEach(appServices, function (s) {
        //    s.selected = true;
        //});
        var services = _.concat(appServices, ossServices);
        var sortedServices = _.orderBy(services, { selected: true }, 'desc');
        var uniqServices = _.uniqBy(sortedServices, 'id');

        return customerModelService.resolveSurveyServices(uniqServices)
            .then(function (services) {
                customerModelService.setCustomerConcernsServices(services);
                return services;
            });
    }

    function loadCustomerConcerns(force) {
        var appointment = customerModelService.getCurrentAppointment();
        var promise;
        if (appointment) {

            var result = customerModelService.getCustomerConcernsServices();
            if (result.length && !force) {
                var deferred = $q.defer();
                deferred.resolve(result);
                return deferred.promise;
            }

            promise = appointment.resolveCustomerConcernsServices()
                .then(function (result) {
                    return processServices(appointment.services.repair, result);
                })
        }
        else {
            promise = customerModelService.resolveCustomerConcernsServices(customerModelService.getCurrentVehicle())
        }
        return promise;
    }

    //init
    //
    //@description
    //entry point into the controller cient logic
    function init() {

        $scope.contentReady = false;

        var currentCCS = customerModelService.getCustomerConcernsServices();
        //customer concerns services storage
        $scope.customerConcernsServices = [];
        // to share variable between subscopes
        $scope.shared = {};

        var deferred = $q.defer();

        loadCustomerConcerns()
            .then(function (r) {
                deferred.resolve(r);
            })
            .catch(function (e) {
                deferred.reject(e);
            });

        $scope.bookAppoimentServicesLoader.addPromise(
            deferred.promise
                .then(function (result) {
                    $scope.customerConcernsServices = _.orderBy(result, ['selected', 'name'], ['desc', 'asc']);

                    if (currentCCS.length) {
                        _.forEach(result, function (o) {
                            var service = _.find(currentCCS, { id: o.id });
                            if (service) {
                                o.selected = service.selected;
                                o.comment = service.comment;
                            }
                        });
                    }
                }.bind(this))
                .finally(function () {
                    $scope.contentReady = true;
                })
        );
    }

    //filterCustomerConcernsServices
    //
    //@description
    //Filters customer concerns services by the given
    //filter query string
    $scope.filterCustomerConcernsServices = function () {
        //use the method of the parent scope to filter the services
        $scope.customerConcernsServices = $scope.filterServices(customerModelService.getCustomerConcernsServices(), $scope.serviceFilterQuery, 'name');
    };

    $scope.hideOnUiServiceFilter = function(s) {
        return !s.hideOnUi || s.selected;
    }

    //start the current controller
    init();
};
CustomerConcernsCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'ssWidgetService', '$q', '$timeout', 'authToken'];

module.exports = CustomerConcernsCtrl;
